module.exports = __webpack_public_path__ + "static/media/granada.66c10a3b.jpg";